import { inject } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { filter, from, map, Observable, startWith, switchMap } from 'rxjs';

const HELP_QUERY_PARAM = 'help';

/**
 * Emits whenever a navigation carries `?help=open`, after removing the parameter from the URL.
 * Must be called in an injection context.
 */
export function helpDeepLinkOpened$(): Observable<void> {
  const router = inject(Router);
  return router.events.pipe(
    filter(event => event instanceof NavigationEnd),
    map(event => event.urlAfterRedirects),
    // the panel may be created after the initial navigation already ended
    startWith(router.url),
    map(url => router.parseUrl(url)),
    filter(urlTree => urlTree.queryParams[HELP_QUERY_PARAM] === 'open'),
    switchMap(urlTree => {
      delete urlTree.queryParams[HELP_QUERY_PARAM];
      return from(router.navigateByUrl(urlTree, { replaceUrl: true }));
    }),
    map(() => undefined)
  );
}
